<template>
  <div class="ml-auto">
    <b-dropdown
      size="sm"
      id="bulk-actions"
      text="Műveletek"
      :disabled="selection.length === 0 || processing"
      v-if="buttonActions.length > 1"
      class="ml-auto"
    >
      <template v-slot:button-content>
        <b-spinner
          v-show="processing"
          label="Folyamatban"
          small
        />
        <span>Műveletek</span>
      </template>
      <b-dropdown-item-button
        v-for="(action, index) in buttonActions"
        :key="`bb${index}`"
        :variant="action.variant"
        @click="confirm(action)"
      >
        {{ action.text }}
      </b-dropdown-item-button>
    </b-dropdown>
    <b-button
      v-if="buttonActions.length === 1"
      size="sm"
      id="bulk-action"
      :disabled="selection.length === 0 || processing"
      :variant="buttonAction.variant"
      @click="confirm(buttonAction)"
    >
      <div class="d-flex">
        <b-spinner
          v-show="processing"
          label="Folyamatban"
          class="mr-1"
          small
        />
        <span>{{ buttonAction.text }}</span>
      </div>
    </b-button>
  </div>
</template>
<script>
const defaultAction = {
  text: '',
  value: '',
  variant: 'primary',
  confirmation: 'Biztosan végre szeretnéd hajtani a műveletet?',
  callback: () => false
}

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    selection: {
      type: Array,
      default: () => ([]),
      required: true
    },
    actions: {
      type: Array,
      default: () => ([]),
    },
    processing: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    buttonActions() {
      return _.map(this.actions, action => ({
        ...defaultAction,
        ...action,
      }))
    },
    buttonAction() {
      return this.buttonActions[0]
    }
  },
  methods: {
    confirm(action) {
      if(action.confirmation !== false && action.confirmation.length !== 0) {
        this.$bvModal.msgBoxConfirm(action.confirmation, {
          title: action.text,
          okVariant: action.variant,
          okTitle: 'OK',
          cancelTitle: 'Mégsem'
        }).then(value => {
          if(value) {
            action.callback(this.selection)
          }
        })
      } else {
        action.callback(this.selection)
      }
    }
  }
}
</script>